// @flow
import ModalFormUnavailable from 'components/Modal/ModalFormUnavailable'
import { ResourceResponseContext } from 'components/ResourceFill/providers/ResourceResponseProvider'
import { ResourceSessionsContext } from 'components/ResourceFill/providers/ResourceSessionsProvider'
import { ResourceSharedContext } from 'components/ResourceFill/providers/ResourceSharedProvider'
import * as React from 'react'

function ResourceFillModalUnavailable(): React.Node {
  const { isPacket } = React.useContext(ResourceSharedContext) || {}

  const { response } = React.useContext(ResourceResponseContext) || {}

  const { sessions, sessionId } =
    React.useContext(ResourceSessionsContext) || {}

  const currentSession = sessions && sessionId ? sessions[sessionId] : null

  return (
    <ModalFormUnavailable
      hideButton
      description="Sorry, this form is not available anymore"
      isVisible={!currentSession || response?.form?.enabled === false}
      title={`${isPacket ? 'Packet' : 'Form'} not available`}
    />
  )
}

export default ResourceFillModalUnavailable
